import makeStyles from '@mui/styles/makeStyles';
import { BREAKPOINTS, COLORS } from 'constants/styles';

export default makeStyles(
  {
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: 40,
      backgroundColor: '#ffffff',
      borderRadius: 30,

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        backgroundColor: COLORS.clear,
        padding: 24,
      },
    },
    header: {
      display: 'flex',
      alignItems: 'center',
    },
    titleLabel: {
      fontWeight: 700,
      fontSize: 30,
      lineHeight: '32px',
    },
    closeButton: {
      border: 0,
      cursor: 'pointer',
      marginLeft: 'auto',
    },
    form: {
      marginTop: 30,

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        borderRadius: 20,
        padding: 20,
        marginTop: 20,
        backgroundColor: '#ffffff',
      },
    },
  },
  { name: 'ContactSalesModal' },
);
